import * as Sentry from '@sentry/vue';
export var ItemClosingStatusEnum;
(function (ItemClosingStatusEnum) {
    ItemClosingStatusEnum["closed"] = "closed";
    ItemClosingStatusEnum["alreadyClosed"] = "already_closed";
    ItemClosingStatusEnum["unhandledError"] = "unhandled_error";
})(ItemClosingStatusEnum || (ItemClosingStatusEnum = {}));
const closeRecords = new Map();
export var ItemCloseRecordSource;
(function (ItemCloseRecordSource) {
    ItemCloseRecordSource[ItemCloseRecordSource["wl"] = 0] = "wl";
    ItemCloseRecordSource[ItemCloseRecordSource["binance"] = 1] = "binance";
})(ItemCloseRecordSource || (ItemCloseRecordSource = {}));
export const createItemCloseRecord = (dispatch, { by, id, item }) => {
    const oldItem = closeRecords.get(id);
    if (oldItem !== undefined) {
        window.clearTimeout(oldItem.timer);
    }
    const timer = window.setTimeout(() => {
        const record = closeRecords.get(id);
        if (record === undefined) {
            return;
        }
        if (record.wl && !record.binance) {
            dispatch('reloadByError', { cause: 'Item не закрылся через 5 секунд' });
        }
        else {
            closeRecords.delete(id);
        }
    }, 5 * 1000);
    closeRecords.set(id, {
        timer,
        wl: by === ItemCloseRecordSource.wl,
        binance: by === ItemCloseRecordSource.binance,
        item
    });
};
export const updateItemCloseRecord = (dispatch, { by, id }) => {
    const record = closeRecords.get(id);
    if (record === undefined) {
        if (by === ItemCloseRecordSource.wl) {
            dispatch('reloadByError', { cause: 'already_closed более 5 секунд назад' });
        }
        else {
            Sentry.captureException(new Error('Binance prislal huinu'), { extra: { cause: 'Хотели закрыть несуществующий item' } });
        }
        return;
    }
    const isBinanceClosed = by === ItemCloseRecordSource.binance || record.binance;
    const isWlClosed = by === ItemCloseRecordSource.wl || record.wl;
    closeRecords.set(id, Object.assign(Object.assign({}, record), { binance: isBinanceClosed, wl: isWlClosed }));
};
export const getCloseRecordById = (id) => closeRecords.get(id);
